export default __webpack_public_path__ + "static/media/5.eeaf19d1.png";